import { ErrorMessage, Field, FieldArray, Form, Formik } from "formik";
import moment from "moment/moment";
import React, { useEffect, useRef, useState } from "react";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import dayjs from "dayjs";
import { addHours } from "date-fns";
import { toast } from "react-toastify";
import { toastProperties } from "../../../commons/Toast/Toaster";
import CustomConfirmBox from "../../DashBoard/customConfirmBox";
import CustomTimePicker from "../../../components/TimePicker/customTimePicker";
import bankingService from "../../../components/Services/banking.service";
import { disableButton, enableButton } from "../../../store/ButtonFlag/actions";
import { getBankingCapacityall } from "../../../store/Banking/actions";
import documentUploadService from "../../../components/Services/documentUpload.service";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import UploadedDocument from "../../Documents/UploadedDocument";
import { Preview } from "@mui/icons-material";

export const BankingSlot = ({
  isOpen,
  handleSubmit,
  isDirectConnect,
  duplicate,
  compId,
}) => {
  console.debug(isDirectConnect);
  const dispatch = useDispatch();
  const formikRef = useRef();
  let isEditCase = typeof isOpen == "object";
  const energyTypes = useSelector(
    (state) => state?.consumerCapacityReducer?.energyTypes || []
  );
  const isButtonEnabled = useSelector(
    (state) => state?.buttonReducer?.isButtonEnabled
  );
  let energyVal = energyTypes?.filter(
    (item) => isOpen?.energyTypeId === item?.id
  );
  const fileInputRef = useRef(null);
  const [holdBtnText, setHoldBtnText] = useState("Hold");
  const [holdOpen, setHoldOpen] = useState(false);
  const [withdrawOpen, setWithdrawOpen] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState(null);
  const [selectedFileData, setSelectedFileData] = useState(null);
  const [isPdfOpen, setIsPdfOpen] = useState(false);
  const [viewDoc, setViewDoc] = useState(duplicate || isDirectConnect);

  const getDocDataById = (id, viewFile) => {
    documentUploadService
      .getDocumentById(id)
      .then((response) => {
        if (response?.data?.code === 200) {
          formikRef.current.setFieldValue("TENDER", response?.data?.data);
          if (viewFile) {
            let fileTypeSplit = response?.data?.data?.fileName.split(".");
            setSelectedFiles(fileTypeSplit[fileTypeSplit?.length - 1]);
            setSelectedFileData(response?.data?.data?.fileInBytes);
            setIsPdfOpen(true);
          }
        }
      })
      .catch((err) => console.log("Api call Error:", err));
  };

  useEffect(() => {
    if (isEditCase) {
      isOpen?.tenderDocumentId && getDocDataById(isOpen?.tenderDocumentId);
    }
  }, []);

  const handleViewFile = (item) => {
    getDocDataById(item?.id, true);
  };
  const handleClosePDFModal = () => {
    setIsPdfOpen(false);
  };
  const formatDate = (date, editCase) => {
    return editCase ? new Date(date) : moment(date).format("DD-MMM-YYYY");
  };
  // Function to format date ranges array
  const formatDateRanges = (dateRanges, editCase, mainVal) => {
    return dateRanges.map((range) => ({
      ...range,
      requiredQty: range?.requiredQty || mainVal?.quantityRequired,
      minimumQty: range?.minimumQty || mainVal?.minQuantity,
      dateStartAt: formatDate(range.dateStartAt, editCase),
      dateEndAt: formatDate(range.dateEndAt, editCase),
      slotEndAt: editCase
        ? range.slotEndAt === "23:59"
          ? "24:00"
          : range.slotEndAt
        : range.slotEndAt === "24:00"
        ? "23:59"
        : range.slotEndAt,
      rtc:
        range.slotStartAt === "00:00" && range.slotEndAt === "23:59"
          ? true
          : false,
    }));
  };
  const initialValues = {
    energyRequirementType: isEditCase
      ? isOpen?.energyTypeId
        ? energyTypes?.filter((item) => isOpen?.energyTypeId === item?.id)?.[0]
            ?.genType
        : "ANY"
      : "",
    energyTypeId: isEditCase ? isOpen?.energyTypeId : "",
    bankingFactor: isEditCase ? isOpen?.bankingFactor : "",
    timeOfDrawalFactor: isEditCase ? isOpen?.timeOfDrawlFactor : "",
    expiryDate: isEditCase ? new Date(isOpen?.expiryAt) : "",
    expiryTime: isEditCase
      ? isOpen?.expiryAt && moment(isOpen?.expiryAt).format("HH:mm")
      : "",
    applyTimeOfDrawalFactor: isEditCase
      ? isOpen?.applyTimeOfDrawlFactor === true
        ? 1
        : 2
      : "",
    injectionDateRanges: isEditCase
      ? formatDateRanges(isOpen?.bankingSlotInjects, isEditCase)
      : [
          {
            dateStartAt: null,
            slotStartAt: null,
            dateEndAt: null,
            slotEndAt: null,
            rtc: false,
            requiredQty: null,
            minimumQty: null,
          },
        ],
    drawlDateRanges: isEditCase
      ? formatDateRanges(isOpen?.bankingSlotDrawls, isEditCase)
      : [
          {
            dateStartAt: null,
            slotStartAt: null,
            dateEndAt: null,
            slotEndAt: null,
            rtc: false,
            requiredQty: null,
            minimumQty: null,
          },
        ],
    quantityRequired: isEditCase ? isOpen?.requiredQty : 0,
    minQuantity: isEditCase ? isOpen?.minimumQty : 0,
    minSlots: isEditCase ? isOpen?.minimumSlots : "",
    drawlTradingMargin: isEditCase
      ? isOpen?.isTradingMarginDrawl === true
        ? 1
        : 2
      : "",
    injectionTradingMargin: isEditCase
      ? isOpen?.isTradingMarginInject === true
        ? 1
        : 2
      : "",
    drawlTradingMarginPercentage: isEditCase ? isOpen?.tradingMarginDrawl : "",
    injectionTradingMarginPercentage: isEditCase
      ? isOpen?.tradingMarginInject
      : "",
    deliveryPoint: isEditCase
      ? isOpen?.deliveryPoint
      : "Regional Periphery of Exporting Utility",
    drawlLossAdjustment: isEditCase
      ? isOpen?.drawlRangeLossAdjustment
      : "Charges and losses borne by respective parties till their delivery point",
    injectionLossAdjustment: isEditCase
      ? isOpen?.injectRangeLossAdjustment
      : "Charges and losses borne by respective parties till their delivery point",
    TENDER: duplicate || isDirectConnect ? "" : "",
    comments: isEditCase ? isOpen?.comments : "",
    gnaepleListing: isEditCase ? isOpen?.gnaepleListing : "",
    settlementRate: isEditCase ? isOpen?.settlementRate : "",
  };

  const handleFormSubmit = (values) => {
    disableButton()(dispatch);
    let slotStartAt = values.slotStartAt;
    let slotEndAt = values.slotEndAt;
    let expiryTime = values.expiryTime;
    if (typeof slotStartAt !== "string") {
      slotStartAt = dayjs(slotStartAt).format("HH:mm");
    }
    if (typeof slotEndAt !== "string") {
      slotEndAt = dayjs(slotEndAt).format("HH:mm");
    }
    if (typeof expiryTime !== "string") {
      expiryTime = dayjs(expiryTime).format("HH:mm");
    }

    if (isDirectConnect || duplicate) {
      let reqBody = {
        id: null,
        companyId: null,
        tenderDocumentId: values.TENDER?.id,
        name: null,
        energyTypeId: values.energyTypeId,
        deliveryPoint: values.deliveryPoint,
        requiredQty: values.quantityRequired,
        minimumQty: values.minQuantity,
        minimumSlots: values.minSlots,
        bankingFactor: values?.bankingFactor,
        applyTimeOfDrawlFactor:
          values?.applyTimeOfDrawalFactor == 1 ? true : false,
        timeOfDrawlFactor: values?.timeOfDrawalFactor,
        drawlRangeLossAdjustment: values?.drawlLossAdjustment,
        isTradingMarginDrawl: values.drawlTradingMargin == 1 ? true : false,
        tradingMarginDrawl: values.drawlTradingMarginPercentage,
        injectRangeLossAdjustment: values.injectionLossAdjustment,
        isTradingMarginInject:
          values.injectionTradingMargin == 1 ? true : false,
        tradingMarginInject: values.injectionTradingMarginPercentage,
        gnaepleListing: values.gnaepleListing,
        comments: values.comments,
        settlementRate: values.settlementRate,
        expiryAt: `${moment(values.expiryDate).format(
          "DD-MMM-YYYY"
        )} ${expiryTime}`,
        bankingSlotDrawls: duplicate
          ? removeKeyValue(
              formatDateRanges(values.drawlDateRanges, "", values),
              "bankingListingId"
            )
          : removeKeyValue(
              formatDateRanges(values.injectionDateRanges, "", values),
              "bankingListingId"
            ),
        bankingSlotInjects: duplicate
          ? removeKeyValue(
              formatDateRanges(values.injectionDateRanges, "", values),
              "bankingListingId"
            )
          : removeKeyValue(
              formatDateRanges(values.drawlDateRanges, "", values),
              "bankingListingId"
            ),
      };
      directCreateAndConnect(reqBody);
    } else {
      let reqBody = {
        id: isEditCase ? isOpen?.id : null,
        companyId: isEditCase ? isOpen?.company?.companyId : compId || null,
        tenderDocumentId: values.TENDER?.id,
        name: isEditCase ? isOpen?.name : null,
        energyTypeId: values.energyTypeId,
        deliveryPoint: values.deliveryPoint,
        requiredQty: values.quantityRequired,
        minimumQty: values.minQuantity,
        minimumSlots: values.minSlots,
        bankingFactor: values?.bankingFactor,
        applyTimeOfDrawlFactor:
          values?.applyTimeOfDrawalFactor == 1 ? true : false,
        timeOfDrawlFactor: values?.timeOfDrawalFactor,
        drawlRangeLossAdjustment: values?.drawlLossAdjustment,
        isTradingMarginDrawl: values.drawlTradingMargin == 1 ? true : false,
        tradingMarginDrawl: values.drawlTradingMarginPercentage,
        injectRangeLossAdjustment: values.injectionLossAdjustment,
        isTradingMarginInject:
          values.injectionTradingMargin == 1 ? true : false,
        tradingMarginInject: values.injectionTradingMarginPercentage,
        gnaepleListing: values.gnaepleListing,
        comments: values.comments,
        settlementRate: values.settlementRate,
        expiryAt: `${moment(values.expiryDate).format(
          "DD-MMM-YYYY"
        )} ${expiryTime}`,
        bankingSlotDrawls: formatDateRanges(values.drawlDateRanges, "", values),
        bankingSlotInjects: formatDateRanges(
          values.injectionDateRanges,
          "",
          values
        ),
      };
      createBankingListing(reqBody);
    }
  };

  const removeKeyValue = (array, key) => {
    array.forEach((obj) => {
      delete obj[key];
      delete obj["id"];
    });
    return array;
  };

  const directCreateAndConnect = (reqBody) => {
    console.debug(reqBody);
    let bankListEndPoint = bankingService.createBanking(reqBody);
    bankListEndPoint
      .then((response) => {
        if (response?.data?.code === 200) {
          let listID = response?.data?.data?.id;
          if (duplicate) {
            handleSubmit();
            enableButton()(dispatch);
            toast.success(response?.data?.message, toastProperties);
            getBankingCapacityall()(dispatch);
          } else {
            directConnect({
              listID,
            });
            toast.success(response?.data?.message, toastProperties);
          }
        } else {
          enableButton()(dispatch);
        }
      })
      .catch((err) => console.log("Api call Error:", err));

    console.debug("create and connect");
  };

  const directConnect = ({ listID }) => {
    disableButton()(dispatch);
    const requestBody = {
      bankingListingId: listID,
      againstBankingListingId: isOpen?.id,
    };
    bankingService
      .placeBankingConnectionRequest(requestBody)
      .then((response) => {
        if (response?.data?.code === 200) {
          handleSubmit();
          enableButton()(dispatch);
          toast.success(response?.data?.message, toastProperties);
        } else if (response?.data?.code !== 200) {
          enableButton()(dispatch);
        }
      })
      .catch((error) => {
        console.error("API call error", error);
        enableButton()(dispatch);
      });
  };

  const createBankingListing = (reqBody) => {
    let bankListEndPoint = isEditCase
      ? bankingService.updateBankingListing(reqBody)
      : bankingService.createBanking(reqBody);
    bankListEndPoint
      .then((response) => {
        if (response?.data?.code === 200) {
          getBankingCapacityall()(dispatch);
          handleSubmit();
          enableButton()(dispatch);
          toast.success(response?.data?.message, toastProperties);
        } else {
          enableButton()(dispatch);
        }
      })
      .catch((err) => console.log("Api call Error:", err));
  };
  const validationSchema = Yup.object().shape({
    expiryDate: Yup.date().required("Required Field"),
    expiryTime: Yup.string().required("Required Field"),
    bankingFactor: Yup.number()
      .test("valueRange", "Value must be positive number", (value) => {
        if (value === undefined || value === null) {
          return true;
        }
        const decimal = String(value).split(".")[1];
        return value >= 0;
      })
      .required("Required Field,Only Numbers are allowed"),
    // timeOfDrawalFactor: Yup.number()
    //   .test("valueRange", "Value must be positive number", (value) => {
    //     if (value === undefined || value === null) {
    //       return true;
    //     }
    //     const decimal = String(value).split(".")[1];
    //     return value >= 0;
    //   })
    //   .required("Required Field,Only Numbers are allowed"),
    energyRequirementType: Yup.string().required("Required field"),
    drawlTradingMargin: Yup.string().required("Required field"),
    injectionDateRanges: Yup.array()
      .of(
        Yup.object().shape({
          dateStartAt: Yup.string().required("Required"), // these constraints take precedence
          dateEndAt: Yup.string().required("Required"), // these constraints take precedence
          slotStartAt: Yup.string().required("Required"), // these constraints take precedence
          slotEndAt: Yup.string().required("Required"), // these constraints take precedence
        })
      )
      .required("Range Required"), // these constraints are shown if and only if inner constraints are satisfied
    drawlDateRanges: Yup.array()
      .of(
        Yup.object().shape({
          dateStartAt: Yup.string().required("Required"), // these constraints take precedence
          dateEndAt: Yup.string().required("Required"), // these constraints take precedence
          slotStartAt: Yup.string().required("Required"), // these constraints take precedence
          slotEndAt: Yup.string().required("Required"), // these constraints take precedence
        })
      )
      .required("Range Required"), // these constraints are shown if and only if inner constraints are satisfied
    minQuantity: Yup.number()
      .test(
        "valueRange",
        "Value must be between 0 and 10,000 with 3 decimal places",
        (value) => {
          if (value === undefined || value === null) {
            return true;
          }
          const decimal = String(value).split(".")[1];
          return (
            value >= 0 && value <= 10000 && (decimal?.length <= 3 || !decimal)
          );
        }
      )
      .required("Required Field"),
    minSlots: Yup.number().required("Required Field"),
    quantityRequired: Yup.number()
      .test(
        "valueRange",
        "Value must be between 0 and 10,000 with 3 decimal places",
        (value) => {
          if (value === undefined || value === null) {
            return true;
          }
          const decimal = String(value).split(".")[1];
          return (
            value >= 0 && value <= 10000 && (decimal?.length <= 3 || !decimal)
          );
        }
      )
      .required("Required Field"),
    deliveryPoint: Yup.string().required("Required Field"),
    drawlLossAdjustment: Yup.string().required("Required Field"),
    injectionLossAdjustment: Yup.string().required("Required Field"),
    injectionTradingMargin: Yup.string().required("Required Field"),
    settlementRate: Yup.string().required("Required Field"),
    // TENDER: Yup.mixed().required("Please Upload Document"),
  });

  const handleHold = () => {
    setHoldOpen(true);
  };

  const handleHoldClose = () => {
    disableButton()(dispatch);
    const data = {
      id: isOpen?.id,
      status: isOpen?.status === "HOLD" ? "ACTIVE" : "HOLD",
    };
    bankingService
      .updateBankingListingStatus(data)
      .then((response) => {
        if (response?.data?.code === 200) {
          setHoldOpen(false);
          getBankingCapacityall()(dispatch);
          handleSubmit();
          enableButton()(dispatch);
          toast.success("Status updated successfully", toastProperties);
        } else if (response?.data?.code !== 200) {
          enableButton()(dispatch);
        }
      })
      .catch((error) => {
        console.error("Api call Error :", error);
        enableButton()(dispatch);
      });
  };
  const handleCloseNo = () => {
    setHoldOpen(false);
  };

  const handleWithdraw = () => {
    setWithdrawOpen(!withdrawOpen);
  };
  const handleWithdrawClose = () => {
    disableButton()(dispatch);
    const data = {
      id: isOpen?.id,
      status: "WITHDRAWN",
    };
    bankingService
      .updateBankingListingStatus(data)
      .then((response) => {
        if (response?.data?.code === 200) {
          setWithdrawOpen(false);
          getBankingCapacityall()(dispatch);
          handleSubmit();
          enableButton()(dispatch);
          toast.success(
            "This capacity has been withdrawn successfully",
            toastProperties
          );
        } else if (response?.data?.code !== 200) {
          enableButton()(dispatch);
        }
      })
      .catch((error) => {
        console.error("Api call Error :", error);
        enableButton()(dispatch);
      });
  };

  const numberInputOnWheelPreventChange = (e) => {
    // Prevent the input value change
    e.target.blur();
    // Prevent the page/container scrolling
    e.stopPropagation();
    // Refocus immediately, on the next tick (after the current function is done)
    setTimeout(() => {
      e.target.focus();
    }, 500);
  };
  const handleProofOfPayment = (e, setFieldValue, key, type) => {
    const fun = async (e) => {
      const fileList = e?.target?.files;
      if (fileList.length > 0) {
        const file = fileList[0];
        let extension = file.name.split(".").pop();
        let fileSize = file.size / 1024 / 1024;
        let extList = ["pdf"];
        if (fileSize < 10) {
          if (extList.includes(extension)) {
            let formData = new FormData();
            formData.append("file", file);
            const config = {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            };
            let data = (
              await documentUploadService.documentUpload(type, formData, config)
            )?.data;
            if (data?.data) {
              setFieldValue(key, data?.data || "");
              toast.success("Uploaded Successfully", toastProperties);
            } else {
              fileInputRef.current.value = null;
              toast.error("Failed to upload File", toastProperties);
              setFieldValue(key, "");
            }
          } else {
            fileInputRef.current.value = null;
            setFieldValue(key, "");
            toast.error("Only Pdf formats can be uploaded", toastProperties);
          }
        } else {
          fileInputRef.current.value = null;
          toast.error("File Size Cannot Exceed 10mb", toastProperties);
          setFieldValue(key, "");
        }
      } else {
        setFieldValue(key, "");
        fileInputRef.current.value = null;
      }
    };
    fun(e);
    setViewDoc(false);
  };

  return (
    <>
      {isPdfOpen && (
        <UploadedDocument
          fileData={selectedFileData}
          handleCloseModal={handleClosePDFModal}
          fileType={selectedFiles}
          isOpen={isPdfOpen}
        />
      )}
      <Modal
        show={Boolean(isOpen)}
        onHide={() => handleSubmit("")}
        dialogClassName="my-modal-banking-slot"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {duplicate ? (
              <>Verify</>
            ) : (
              <>
                {isDirectConnect ? (
                  <>Add and Connect</>
                ) : (
                  <>{isEditCase ? "Edit" : "Add"}</>
                )}
              </>
            )}

            {" Listing"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="m-1 table-scrollY">
          <div className="container-fluid">
            <div className="row m-1">
              <div className="col-md-12">
                <div>
                  <Formik
                    innerRef={formikRef}
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={(values) => {
                      handleFormSubmit(values);
                    }}
                    validateOnMount={false}
                    validate={(values) => {
                      const errors = {
                        injectionDateRanges: [], // array to store errors for injectionDateRanges
                        drawlDateRanges: [], // array to store errors for drawlDateRanges
                      };
                      const currentDateTime = new Date();
                      const maxStartTime = addHours(currentDateTime, 3);

                      // ... (other existing validation logic)
                      if (
                        values.energyRequirementType !== "ANY" &&
                        (values.energyTypeId === "" ||
                          values.energyTypeId === undefined)
                      ) {
                        errors.energyTypeId = "Required Field";
                      }
                      if (values.injectionDateRanges) {
                        values.injectionDateRanges.forEach(
                          (dateRange, index) => {
                            const selectedStartTime = moment(
                              dateRange.slotStartAt,
                              "HH:mm"
                            );
                            const selectedEndTime = moment(
                              dateRange.slotEndAt,
                              "HH:mm"
                            );
                            const selectedExpiryTime = moment(
                              dateRange.expiryTime,
                              "HH:mm"
                            );

                            // ... (apply validations for each date range)

                            // Example: Validate slotStartAt and slotEndAt for each date range
                            const minEndTime = selectedStartTime.add(
                              15,
                              "minutes"
                            );
                            if (selectedEndTime.isBefore(minEndTime)) {
                              errors.injectionDateRanges[index] = {
                                ...errors.injectionDateRanges[index], // copy existing errors for this dateRange
                                slotEndAt:
                                  "End time must be at least 15 minutes after start time.",
                              };
                            }

                            // ... (apply other validations for each date range)
                          }
                        );
                      }
                      if (values.drawlDateRanges) {
                        values.drawlDateRanges.forEach((dateRange, index) => {
                          const selectedStartTime = moment(
                            dateRange.slotStartAt,
                            "HH:mm"
                          );
                          const selectedEndTime = moment(
                            dateRange.slotEndAt,
                            "HH:mm"
                          );
                          const selectedExpiryTime = moment(
                            dateRange.expiryTime,
                            "HH:mm"
                          );

                          // ... (apply validations for each date range)

                          // Example: Validate slotStartAt and slotEndAt for each date range
                          const minEndTime = selectedStartTime.add(
                            15,
                            "minutes"
                          );
                          if (selectedEndTime.isBefore(minEndTime)) {
                            errors.drawlDateRanges[index] = {
                              ...errors.drawlDateRanges[index], // copy existing errors for this drawlDateRange
                              slotEndAt:
                                "End time must be at least 15 minutes after start time.",
                            };
                          }
                        });
                      }
                      if (
                        Object.keys(errors).every(
                          (key) => errors[key].length === 0
                        )
                      ) {
                        return {}; // Return empty object when no errors found
                      }
                      return errors;
                    }}
                  >
                    {({
                      isSubmitting,
                      setFieldTouched,
                      setFieldValue,
                      values,
                      handleBlur,
                      errors,
                    }) => {
                      let startTimeValue = values.slotStartAt;
                      if (typeof startTimeValue == "string") {
                        startTimeValue = dayjs(new Date())
                          .set("hour", parseInt(startTimeValue.split(":")[0]))
                          .set(
                            "minute",
                            parseInt(startTimeValue.split(":")[1])
                          );
                      }
                      return (
                        <Form>
                          <div className="row justify-contnet-center align-items-center">
                            <div className="col-md-12">
                              <div className="">
                                <div className="row mb-3">
                                  <div className="col-md-4">
                                    <div className="mb-3 fw-medium">
                                      Energy Requirement Type*
                                    </div>
                                    <div className="d-flex gap-3">
                                      <div className="form-check-flex">
                                        <Field
                                          className="form-check-input"
                                          type="radio"
                                          name="energyRequirementType"
                                          value="RENEWABLE"
                                          id="energyRequirementType1"
                                          checked={
                                            "RENEWABLE" ==
                                            values.energyRequirementType
                                          }
                                          onBlur={() =>
                                            setFieldValue("energyTypeId", "")
                                          }
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor="energyRequirementType1"
                                        >
                                          Renewable
                                        </label>
                                      </div>
                                      <div className="form-check-flex">
                                        <Field
                                          className="form-check-input"
                                          type="radio"
                                          name="energyRequirementType"
                                          value="NON_RENEWABLE"
                                          id="energyRequirementType2"
                                          checked={
                                            "NON_RENEWABLE" ==
                                            values.energyRequirementType
                                          }
                                          onClick={() =>
                                            setFieldValue("energyTypeId", "")
                                          }
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor="energyRequirementType2"
                                        >
                                          Non-Renewable
                                        </label>
                                      </div>
                                      <div className="form-check-flex">
                                        <Field
                                          className="form-check-input"
                                          type="radio"
                                          name="energyRequirementType"
                                          value="ANY"
                                          id="energyRequirementType3"
                                          checked={
                                            "ANY" ==
                                            values.energyRequirementType
                                          }
                                          onClick={() =>
                                            setFieldValue("energyTypeId", "")
                                          }
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor="energyRequirementType3"
                                        >
                                          Any
                                        </label>
                                      </div>
                                    </div>
                                    <ErrorMessage
                                      name="energyRequirementType"
                                      className="text-danger"
                                      component="div"
                                    />
                                  </div>
                                  {values.energyRequirementType != "ANY" ? (
                                    <div className="col-md-4">
                                      <Field
                                        as="select"
                                        name="energyTypeId"
                                        id="energyTypeId"
                                        className="custom-input"
                                        disabled={
                                          values.energyRequirementType != "ANY"
                                            ? false
                                            : true
                                        }
                                      >
                                        <option value="">Energy Type*</option>
                                        {energyTypes
                                          ?.filter((ite) => {
                                            return values.energyRequirementType ==
                                              "RENEWABLE"
                                              ? ite?.genType == "RENEWABLE"
                                              : values.energyRequirementType ==
                                                "NON_RENEWABLE"
                                              ? ite?.genType == "NON_RENEWABLE"
                                              : "";
                                          })
                                          .map((item) => (
                                            <option
                                              key={item?.id}
                                              value={item?.id}
                                            >
                                              {item?.type}
                                            </option>
                                          ))}
                                      </Field>
                                      <ErrorMessage
                                        name="energyTypeId"
                                        component="div"
                                        className="text-danger"
                                      />
                                    </div>
                                  ) : (
                                    <div className="col-md-4" />
                                  )}
                                  <div className="col-md-4 mb-1 mb-md-0 position-relative">
                                    <label
                                      htmlFor="deliveryPoint"
                                      className="postion-label-dynamic"
                                    >
                                      Delivery Point *
                                    </label>
                                    <Field
                                      type="text"
                                      className="custom-input no-spinner"
                                      placeholder=""
                                      name="deliveryPoint"
                                      value={values.deliveryPoint}
                                    />
                                    <ErrorMessage
                                      name="delivery Point"
                                      component="div"
                                      className="text-danger"
                                    />
                                  </div>
                                </div>
                                <hr className="horizontal-line" />
                                <div className="row mt-3">
                                  <div className="col-md-4 mb-1 mb-md-0 position-relative">
                                    <label
                                      htmlFor="quantityRequired"
                                      className="postion-label-dynamic"
                                    >
                                      Quantity Required(in MW) *
                                    </label>
                                    <Field
                                      type="number"
                                      onWheel={numberInputOnWheelPreventChange}
                                      className="custom-input no-spinner"
                                      placeholder=""
                                      name="quantityRequired"
                                      onKeyDown={(e) => {
                                        if (
                                          e.key === "-" ||
                                          e.key === "+" ||
                                          e.key === "e" ||
                                          e.key === "ArrowUp" ||
                                          e.key === "ArrowDown"
                                        ) {
                                          e.preventDefault();
                                        }
                                      }}
                                    />
                                    <ErrorMessage
                                      name="quantityRequired"
                                      component="div"
                                      className="text-danger"
                                    />
                                  </div>
                                  <div className="col-md-4 mb-1 mb-md-0 position-relative">
                                    <label
                                      htmlFor="minQuantity"
                                      className="postion-label-dynamic"
                                    >
                                      Minimum Quantity(in MW) *
                                    </label>
                                    <Field
                                      type="number"
                                      onWheel={numberInputOnWheelPreventChange}
                                      className="custom-input no-spinner"
                                      placeholder=""
                                      name="minQuantity"
                                      onKeyDown={(e) => {
                                        if (
                                          e.key === "-" ||
                                          e.key === "+" ||
                                          e.key === "e" ||
                                          e.key === "ArrowUp" ||
                                          e.key === "ArrowDown"
                                        ) {
                                          e.preventDefault();
                                        }
                                      }}
                                    />
                                    <ErrorMessage
                                      name="minQuantity"
                                      component="div"
                                      className="text-danger"
                                    />
                                  </div>
                                  <div className="col-md-4 mb-2 mb-md-0 position-relative">
                                    <label
                                      htmlFor="minSlots"
                                      className="postion-label-dynamic"
                                    >
                                      Minimum Slots*
                                    </label>
                                    <Field
                                      type="number"
                                      onWheel={numberInputOnWheelPreventChange}
                                      className="custom-input no-spinner"
                                      placeholder=""
                                      name="minSlots"
                                      onKeyDown={(e) => {
                                        if (
                                          e.key === "-" ||
                                          e.key === "+" ||
                                          e.key === "e" ||
                                          e.key === "ArrowUp" ||
                                          e.key === "ArrowDown"
                                        ) {
                                          e.preventDefault();
                                        }
                                      }}
                                    />
                                    <ErrorMessage
                                      name="minSlots"
                                      component="div"
                                      className="text-danger"
                                    />
                                  </div>
                                </div>
                                <div className="row mt-3">
                                  <div className="col-md-4 mb-2 mb-md-0 position-relative">
                                    <label
                                      htmlFor="bankingFactor"
                                      className="postion-label-dynamic"
                                    >
                                      Banking Factor(%)*
                                    </label>
                                    <Field
                                      type="number"
                                      onWheel={numberInputOnWheelPreventChange}
                                      className="custom-input no-spinner"
                                      placeholder=""
                                      name="bankingFactor"
                                      onKeyDown={(e) => {
                                        if (
                                          e.key === "-" ||
                                          e.key === "+" ||
                                          e.key === "e" ||
                                          e.key === "ArrowUp" ||
                                          e.key === "ArrowDown"
                                        ) {
                                          e.preventDefault();
                                        }
                                      }}
                                    />
                                    <ErrorMessage
                                      name="bankingFactor"
                                      component="div"
                                      className="text-danger"
                                    />
                                  </div>
                                  <div className="col-md-4 mb-2 mb-md-0 position-relative">
                                    <label
                                      htmlFor="settlementRate"
                                      className="postion-label-dynamic"
                                    >
                                      Settlement Rate (₹/KWH)*
                                    </label>
                                    <Field
                                      placeholder={"Eg. DAM + ₹"}
                                      type="text"
                                      onWheel={numberInputOnWheelPreventChange}
                                      className="custom-input no-spinner"
                                      name="settlementRate"
                                      onKeyDown={(e) => {
                                        if (
                                          e.key === "ArrowUp" ||
                                          e.key === "ArrowDown"
                                        ) {
                                          e.preventDefault();
                                        }
                                      }}
                                    />
                                    <ErrorMessage
                                      name="settlementRate"
                                      component="div"
                                      className="text-danger"
                                    />
                                  </div>
                                  <div className="col-md-4 mb-2 mb-md-0 position-relative">
                                    <label
                                      htmlFor="gnaepleListing"
                                      className="postion-label-dynamic"
                                    >
                                      GNA/TGNA/EITHER
                                    </label>
                                    <Field
                                      type="text"
                                      onWheel={numberInputOnWheelPreventChange}
                                      className="custom-input no-spinner"
                                      placeholder=""
                                      name="gnaepleListing"
                                      onKeyDown={(e) => {
                                        if (
                                          e.key === "ArrowUp" ||
                                          e.key === "ArrowDown"
                                        ) {
                                          e.preventDefault();
                                        }
                                      }}
                                    />
                                    <ErrorMessage
                                      name="gnaepleListing"
                                      component="div"
                                      className="text-danger"
                                    />
                                  </div>
                                  {/* <div className="col-md-4 mb-1 mb-md-0 position-relative">
                                    <label
                                      htmlFor="timeOfDrawalFactor"
                                      className="postion-label-dynamic"
                                    >
                                      Time of Drawal Factor (%) *
                                    </label>
                                    <Field
                                      type="number"
                                      onWheel={numberInputOnWheelPreventChange}
                                      className="custom-input no-spinner"
                                      placeholder=""
                                      name="timeOfDrawalFactor"
                                      onKeyDown={(e) => {
                                        if (
                                          e.key === "-" ||
                                          e.key === "+" ||
                                          e.key === "e" ||
                                          e.key === "ArrowUp" ||
                                          e.key === "ArrowDown"
                                        ) {
                                          e.preventDefault();
                                        }
                                      }}
                                    />
                                    <ErrorMessage
                                      name="timeOfDrawalFactor"
                                      component="div"
                                      className="text-danger"
                                    />
                                  </div> */}
                                  {/* <div className="col-md-4">
                                    <div className="mb-3 fw-medium">
                                      Apply Time of Drawal Factor*
                                    </div>
                                    <div className="d-flex gap-3">
                                      <div className="form-check-flex">
                                        <Field
                                          className="form-check-input"
                                          type="radio"
                                          name="applyTimeOfDrawalFactor"
                                          value={1}
                                          id="priceFactor1"
                                          checked={
                                            1 == values.applyTimeOfDrawalFactor
                                          }
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor="priceFactor1"
                                        >
                                          Yes
                                        </label>
                                      </div>
                                      <div className="form-check-flex">
                                        <Field
                                          className="form-check-input"
                                          type="radio"
                                          name="applyTimeOfDrawalFactor"
                                          value={2}
                                          id="priceFactor2"
                                          checked={
                                            2 == values.applyTimeOfDrawalFactor
                                          }
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor="priceFactor2"
                                        >
                                          No
                                        </label>
                                      </div>
                                    </div>
                                    <ErrorMessage
                                      name="energyRequirementType"
                                      className="text-danger"
                                      component="div"
                                    />
                                  </div> */}
                                </div>
                                <hr className="horizontal-line" />
                                <div className="mb-3 fw-medium">
                                  Drawal/Import Range*
                                </div>
                                <div className="row mb-3">
                                  <div className="col-md-6 position-relative">
                                    <label
                                      htmlFor="drawlLossAdjustment"
                                      className="postion-label-dynamic"
                                    >
                                      Loss Adjustment *
                                    </label>
                                    <Field
                                      type="text"
                                      className="custom-input no-spinner"
                                      placeholder="Eg. 4"
                                      name="drawlLossAdjustment"
                                      value={values.drawlLossAdjustment}
                                    />
                                    <ErrorMessage
                                      name="drawlLossAdjustment"
                                      component="div"
                                      className="text-danger"
                                    />
                                  </div>
                                  <div className="col-md-3">
                                    <div className=" fw-medium">
                                      Trading Margin*
                                    </div>
                                    <div className="d-flex gap-3">
                                      <div className="form-check-flex">
                                        <Field
                                          className="form-check-input"
                                          type="radio"
                                          name="drawlTradingMargin"
                                          value={1}
                                          id="tradingMargin1"
                                          checked={
                                            1 == values.drawlTradingMargin
                                          }
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor="tradingMargin1"
                                        >
                                          Yes
                                        </label>
                                      </div>
                                      <div className="form-check-flex">
                                        <Field
                                          className="form-check-input"
                                          type="radio"
                                          name="drawlTradingMargin"
                                          value={2}
                                          id="tradingMargin2"
                                          checked={
                                            2 == values.drawlTradingMargin
                                          }
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor="tradingMargin2"
                                        >
                                          No
                                        </label>
                                      </div>
                                    </div>
                                    <ErrorMessage
                                      name="drawlTradingMargin"
                                      className="text-danger"
                                      component="div"
                                    />
                                  </div>
                                  {values?.drawlTradingMargin == "1" && (
                                    <div className="col-md-3 position-relative">
                                      <label
                                        htmlFor="drawlTradingMarginPercentage"
                                        className="postion-label-dynamic"
                                      >
                                        Trading Margin (₹/kwh) *
                                      </label>
                                      <Field
                                        type="number"
                                        onWheel={
                                          numberInputOnWheelPreventChange
                                        }
                                        className="custom-input no-spinner"
                                        placeholder=""
                                        name="drawlTradingMarginPercentage"
                                        onKeyDown={(e) => {
                                          if (
                                            e.key === "-" ||
                                            e.key === "+" ||
                                            e.key === "e" ||
                                            e.key === "ArrowUp" ||
                                            e.key === "ArrowDown"
                                          ) {
                                            e.preventDefault();
                                          }
                                        }}
                                      />
                                    </div>
                                  )}
                                </div>
                                <FieldArray
                                  name="drawlDateRanges"
                                  render={(arrayHelpers) => (
                                    <div>
                                      {values.drawlDateRanges.map(
                                        (dateRange, index) => (
                                          <div className="row mb-3" key={index}>
                                            <div className="col-md-4">
                                              <div className="row">
                                                <div className="col-md-6 mb-2 mb-md-0">
                                                  <label>Start Date</label>
                                                  <DatePicker
                                                    className="custom-input w-100"
                                                    name={`drawlDateRanges[${index}].dateStartAt`}
                                                    selected={
                                                      dateRange.dateStartAt
                                                    }
                                                    onChange={(date) =>
                                                      setFieldValue(
                                                        `drawlDateRanges[${index}].dateStartAt`,
                                                        date
                                                      )
                                                    }
                                                    minDate={
                                                      isEditCase
                                                        ? values.expiryDate
                                                        : moment().toDate()
                                                    }
                                                    maxDate={
                                                      dateRange.dateEndAt
                                                    }
                                                    onBlur={handleBlur(
                                                      `drawlDateRanges[${index}].dateStartAt`
                                                    )}
                                                    dateFormat="dd-MMM-yyyy"
                                                    placeholderText="Date*"
                                                    autoComplete="off"
                                                    showYearDropdown
                                                    showMonthDropdown
                                                    scrollableMonthYearDropdown
                                                  />
                                                  <ErrorMessage
                                                    name={`drawlDateRanges[${index}].dateStartAt`}
                                                    component="div"
                                                    className="text-danger"
                                                  />
                                                </div>
                                                <div className="col-md-6 mb-2 mb-md-0">
                                                  <label>End Date</label>
                                                  <DatePicker
                                                    className="custom-input w-100"
                                                    name={`drawlDateRanges[${index}].dateEndAt`}
                                                    selected={
                                                      dateRange.dateEndAt
                                                    }
                                                    onChange={(date) =>
                                                      setFieldValue(
                                                        `drawlDateRanges[${index}].dateEndAt`,
                                                        date
                                                      )
                                                    }
                                                    minDate={
                                                      dateRange.dateStartAt
                                                        ? dateRange.dateStartAt
                                                        : moment().toDate()
                                                    }
                                                    onBlur={handleBlur(
                                                      `drawlDateRanges[${index}].dateEndAt`
                                                    )}
                                                    dateFormat="dd-MMM-yyyy"
                                                    placeholderText="Date*"
                                                    autoComplete="off"
                                                    showYearDropdown
                                                    showMonthDropdown
                                                    scrollableMonthYearDropdown
                                                  />
                                                  <ErrorMessage
                                                    name={`drawlDateRanges[${index}].dateEndAt`}
                                                    component="div"
                                                    className="text-danger"
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              <div className="row">
                                                <div className="col-md-6 mb-2 mb-md-0">
                                                  <label>
                                                    <div className="d-flex gap-1">
                                                      Start Time
                                                      <OverlayTrigger
                                                        placement="top"
                                                        overlay={
                                                          <Tooltip>
                                                            Start time must be
                                                            at least 3 hours
                                                            from the current
                                                            time.
                                                          </Tooltip>
                                                        }
                                                      >
                                                        <InfoOutlinedIcon />
                                                      </OverlayTrigger>
                                                      <div className="checkbox-wrapper d-flex gap-1">
                                                        <Field
                                                          type="checkbox"
                                                          name={`drawlDateRanges[${index}].rtc`}
                                                          onClick={(e) => {
                                                            if (
                                                              e.target.checked
                                                            ) {
                                                              dateRange.slotStartAt =
                                                                "00:00";
                                                              dateRange.slotEndAt =
                                                                "24:00";
                                                            } else {
                                                              dateRange.slotStartAt =
                                                                "";
                                                              dateRange.slotEndAt =
                                                                "";
                                                            }
                                                          }}
                                                        />
                                                        <div>RTC</div>
                                                      </div>
                                                    </div>
                                                  </label>
                                                  <CustomTimePicker
                                                    minutesStep={15}
                                                    name={`drawlDateRanges[${index}].slotStartAt`}
                                                    updateTimeToParent={(
                                                      timeText
                                                    ) => {
                                                      setFieldValue(
                                                        `drawlDateRanges[${index}].slotStartAt`,
                                                        timeText
                                                      );
                                                    }}
                                                    time={dateRange.slotStartAt}
                                                    maxHours={24}
                                                    rtcValue={dateRange.rtc}
                                                    hasInititalValues={
                                                      dateRange.rtc ||
                                                      isEditCase
                                                    }
                                                    readOnly={dateRange.rtc}
                                                  />
                                                </div>
                                                <div className="col-md-6 mb-2 mb-md-0">
                                                  <label>End Time</label>
                                                  <div
                                                    style={{ display: "flex" }}
                                                  >
                                                    <CustomTimePicker
                                                      minutesStep={15}
                                                      name={`drawlDateRanges[${index}].slotEndAt`}
                                                      updateTimeToParent={(
                                                        timeText
                                                      ) => {
                                                        setFieldValue(
                                                          `drawlDateRanges[${index}].slotEndAt`,
                                                          timeText
                                                        );
                                                      }}
                                                      time={dateRange.slotEndAt}
                                                      minTime={
                                                        dateRange.slotStartAt
                                                      }
                                                      minTimeDiffInMinutes={15}
                                                      maxHours={25}
                                                      rtcValue={dateRange.rtc}
                                                      readOnly={dateRange.rtc}
                                                      hasInititalValues={
                                                        dateRange.rtc ||
                                                        isEditCase
                                                      }
                                                    />
                                                    <div className="dateRange-btn-group"></div>
                                                  </div>
                                                  <ErrorMessage
                                                    name={`drawlDateRanges[${index}].slotEndAt`}
                                                    component="div"
                                                    className="text-danger"
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              <div className="row">
                                                <div className="col-md-6 mb-2 mb-md-0">
                                                  <label>
                                                    <div className="d-flex gap-1">
                                                      Required Quantity
                                                    </div>
                                                  </label>
                                                  <Field
                                                    type="number"
                                                    onWheel={
                                                      numberInputOnWheelPreventChange
                                                    }
                                                    onChange={(e) =>
                                                      setFieldValue(
                                                        `drawlDateRanges[${index}].requiredQty`,
                                                        e.target.value
                                                      )
                                                    }
                                                    className="custom-input no-spinner"
                                                    placeholder="Eg. 10"
                                                    name={`drawlDateRanges[${index}].requiredQty`}
                                                  />
                                                </div>
                                                <div className="col-md-6 mb-2 mb-md-0">
                                                  <label>
                                                    <div className="d-flex gap-1">
                                                      Minimum Quantity
                                                    </div>
                                                  </label>
                                                  <div
                                                    style={{ display: "flex" }}
                                                  >
                                                    <Field
                                                      onWheel={
                                                        numberInputOnWheelPreventChange
                                                      }
                                                      onChange={(e) =>
                                                        setFieldValue(
                                                          `drawlDateRanges[${index}].minimumQty`,
                                                          e.target.value
                                                        )
                                                      }
                                                      className="custom-input no-spinner"
                                                      placeholder="Eg. 10"
                                                      name={`drawlDateRanges[${index}].minimumQty`}
                                                    />
                                                    <div className="dateRange-btn-group">
                                                      {values.drawlDateRanges
                                                        .length > 1 && (
                                                        <button
                                                          type="button"
                                                          onClick={() =>
                                                            arrayHelpers.remove(
                                                              index
                                                            )
                                                          }
                                                        >
                                                          -
                                                        </button>
                                                      )}
                                                      <button
                                                        type="button"
                                                        onClick={() =>
                                                          arrayHelpers.push({
                                                            dateStartAt: null,
                                                            dateEndAt: null,
                                                            slotStartAt: null,
                                                            slotEndAt: null,
                                                          })
                                                        }
                                                      >
                                                        +
                                                      </button>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div></div>
                                              </div>
                                            </div>
                                          </div>
                                        )
                                      )}
                                    </div>
                                  )}
                                />
                                <hr className="horizontal-line" />
                                <div className="mb-3 fw-medium">
                                  Injection/Return Range*
                                </div>
                                <div className="row mb-3">
                                  <div className="col-md-6 position-relative">
                                    <label
                                      htmlFor="injectionLossAdjustment"
                                      className="postion-label-dynamic"
                                    >
                                      Loss Adjustment *
                                    </label>
                                    <Field
                                      type="text"
                                      className="custom-input no-spinner"
                                      placeholder="Eg. 4"
                                      name="injectionLossAdjustment"
                                    />
                                    <ErrorMessage
                                      name="injectionLossAdjustment"
                                      component="div"
                                      className="text-danger"
                                    />
                                  </div>
                                  <div className="col-md-3">
                                    <div className=" fw-medium">
                                      Trading Margin*
                                    </div>
                                    <div className="d-flex gap-3">
                                      <div className="form-check-flex">
                                        <Field
                                          className="form-check-input"
                                          type="radio"
                                          name="injectionTradingMargin"
                                          value={1}
                                          id="injectionTradingMargin1"
                                          checked={
                                            1 == values.injectionTradingMargin
                                          }
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor="injectionTradingMargin1"
                                        >
                                          Yes
                                        </label>
                                      </div>
                                      <div className="form-check-flex">
                                        <Field
                                          className="form-check-input"
                                          type="radio"
                                          name="injectionTradingMargin"
                                          value={2}
                                          id="injectionTradingMargin2"
                                          checked={
                                            2 == values.injectionTradingMargin
                                          }
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor="injectionTradingMargin2"
                                        >
                                          No
                                        </label>
                                      </div>
                                    </div>
                                    <ErrorMessage
                                      name="injectionTradingMargin"
                                      className="text-danger"
                                      component="div"
                                    />
                                  </div>
                                  {values?.injectionTradingMargin == "1" && (
                                    <div className="col-md-3 position-relative">
                                      <label
                                        htmlFor="injectionTradingMarginPercentage"
                                        className="postion-label-dynamic"
                                      >
                                        Trading Margin (₹/kwh) *
                                      </label>
                                      <Field
                                        type="number"
                                        onWheel={
                                          numberInputOnWheelPreventChange
                                        }
                                        className="custom-input no-spinner"
                                        placeholder=""
                                        name="injectionTradingMarginPercentage"
                                        onKeyDown={(e) => {
                                          if (
                                            e.key === "-" ||
                                            e.key === "+" ||
                                            e.key === "e" ||
                                            e.key === "ArrowUp" ||
                                            e.key === "ArrowDown"
                                          ) {
                                            e.preventDefault();
                                          }
                                        }}
                                      />
                                    </div>
                                  )}
                                </div>
                                <FieldArray
                                  name="injectionDateRanges"
                                  render={(arrayHelpers) => (
                                    <div>
                                      {values.injectionDateRanges.map(
                                        (dateRange, index) => (
                                          <div className="row mb-3" key={index}>
                                            <div className="col-md-4">
                                              <div className="row">
                                                <div className="col-md-6 mb-2 mb-md-0">
                                                  <label>Start Date</label>
                                                  <DatePicker
                                                    className="custom-input w-100"
                                                    name={`injectionDateRanges[${index}].dateStartAt`}
                                                    selected={
                                                      dateRange.dateStartAt
                                                    }
                                                    onChange={(date) =>
                                                      setFieldValue(
                                                        `injectionDateRanges[${index}].dateStartAt`,
                                                        date
                                                      )
                                                    }
                                                    minDate={
                                                      isEditCase
                                                        ? values.expiryDate
                                                        : moment().toDate()
                                                    }
                                                    maxDate={
                                                      dateRange.dateEndAt
                                                    }
                                                    onBlur={handleBlur(
                                                      `injectionDateRanges[${index}].dateStartAt`
                                                    )}
                                                    dateFormat="dd-MMM-yyyy"
                                                    placeholderText="Date*"
                                                    autoComplete="off"
                                                    showYearDropdown
                                                    showMonthDropdown
                                                    scrollableMonthYearDropdown
                                                  />
                                                  <ErrorMessage
                                                    name={`injectionDateRanges[${index}].dateStartAt`}
                                                    component="div"
                                                    className="text-danger"
                                                  />
                                                </div>
                                                <div className="col-md-6 mb-2 mb-md-0">
                                                  <label>End Date</label>
                                                  <DatePicker
                                                    className="custom-input w-100"
                                                    name={`injectionDateRanges[${index}].dateEndAt`}
                                                    selected={
                                                      dateRange.dateEndAt
                                                    }
                                                    onChange={(date) =>
                                                      setFieldValue(
                                                        `injectionDateRanges[${index}].dateEndAt`,
                                                        date
                                                      )
                                                    }
                                                    minDate={
                                                      dateRange.dateStartAt
                                                        ? dateRange.dateStartAt
                                                        : moment().toDate()
                                                    }
                                                    onBlur={handleBlur(
                                                      `injectionDateRanges[${index}].dateEndAt`
                                                    )}
                                                    dateFormat="dd-MMM-yyyy"
                                                    placeholderText="Date*"
                                                    autoComplete="off"
                                                    showYearDropdown
                                                    showMonthDropdown
                                                    scrollableMonthYearDropdown
                                                  />
                                                  <ErrorMessage
                                                    name={`injectionDateRanges[${index}].dateEndAt`}
                                                    component="div"
                                                    className="text-danger"
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              <div className="row">
                                                <div className="col-md-6 mb-2 mb-md-0">
                                                  <label>
                                                    <div className="d-flex gap-1">
                                                      Start Time
                                                      <OverlayTrigger
                                                        placement="top"
                                                        overlay={
                                                          <Tooltip>
                                                            Start time must be
                                                            at least 3 hours
                                                            from the current
                                                            time.
                                                          </Tooltip>
                                                        }
                                                      >
                                                        <InfoOutlinedIcon />
                                                      </OverlayTrigger>
                                                      <div className="checkbox-wrapper d-flex gap-1">
                                                        <Field
                                                          type="checkbox"
                                                          name={`injectionDateRanges[${index}].rtc`}
                                                          onClick={(e) => {
                                                            if (
                                                              e.target.checked
                                                            ) {
                                                              dateRange.slotStartAt =
                                                                "00:00";
                                                              dateRange.slotEndAt =
                                                                "24:00";
                                                            } else {
                                                              dateRange.slotStartAt =
                                                                "";
                                                              dateRange.slotEndAt =
                                                                "";
                                                            }
                                                          }}
                                                        />
                                                        <div>RTC</div>
                                                      </div>
                                                    </div>
                                                  </label>
                                                  <CustomTimePicker
                                                    minutesStep={15}
                                                    name={`injectionDateRanges[${index}].slotStartAt`}
                                                    updateTimeToParent={(
                                                      timeText
                                                    ) => {
                                                      setFieldValue(
                                                        `injectionDateRanges[${index}].slotStartAt`,
                                                        timeText
                                                      );
                                                    }}
                                                    time={dateRange.slotStartAt}
                                                    maxHours={24}
                                                    rtcValue={dateRange.rtc}
                                                    readOnly={dateRange.rtc}
                                                    hasInititalValues={
                                                      dateRange.rtc ||
                                                      isEditCase
                                                    }
                                                  />
                                                  <ErrorMessage
                                                    name={`injectionDateRanges[${index}].slotStartAt`}
                                                    component="div"
                                                    className="text-danger"
                                                  />
                                                </div>
                                                <div className="col-md-6 mb-2 mb-md-0">
                                                  <label>End Time</label>
                                                  <div
                                                    style={{ display: "flex" }}
                                                  >
                                                    <CustomTimePicker
                                                      minutesStep={15}
                                                      name={`injectionDateRanges[${index}].slotEndAt`}
                                                      updateTimeToParent={(
                                                        timeText
                                                      ) => {
                                                        setFieldValue(
                                                          `injectionDateRanges[${index}].slotEndAt`,
                                                          timeText
                                                        );
                                                      }}
                                                      time={dateRange.slotEndAt}
                                                      minTime={
                                                        dateRange.slotStartAt
                                                      }
                                                      minTimeDiffInMinutes={15}
                                                      maxHours={25}
                                                      rtcValue={dateRange.rtc}
                                                      readOnly={dateRange.rtc}
                                                      hasInititalValues={
                                                        dateRange.rtc ||
                                                        isEditCase
                                                      }
                                                    />
                                                  </div>
                                                  <ErrorMessage
                                                    name={`injectionDateRanges[${index}].slotEndAt`}
                                                    component="div"
                                                    className="text-danger"
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              <div className="row">
                                                <div className="col-md-6 mb-2 mb-md-0">
                                                  <label>
                                                    <div className="d-flex gap-1">
                                                      Required Quantity
                                                    </div>
                                                  </label>
                                                  <Field
                                                    type="number"
                                                    onWheel={
                                                      numberInputOnWheelPreventChange
                                                    }
                                                    onChange={(e) =>
                                                      setFieldValue(
                                                        `injectionDateRanges[${index}].requiredQty`,
                                                        e.target.value
                                                      )
                                                    }
                                                    className="custom-input no-spinner"
                                                    placeholder="Eg. 10"
                                                    name={`injectionDateRanges[${index}].requiredQty`}
                                                  />
                                                </div>
                                                <div className="col-md-6 mb-2 mb-md-0">
                                                  <label>
                                                    <div className="d-flex gap-1">
                                                      Minimum Quantity
                                                    </div>
                                                  </label>
                                                  <div
                                                    style={{ display: "flex" }}
                                                  >
                                                    <Field
                                                      onWheel={
                                                        numberInputOnWheelPreventChange
                                                      }
                                                      onChange={(e) =>
                                                        setFieldValue(
                                                          `injectionDateRanges[${index}].minimumQty`,
                                                          e.target.value
                                                        )
                                                      }
                                                      className="custom-input no-spinner"
                                                      placeholder="Eg. 10"
                                                      name={`injectionDateRanges[${index}].minimumQty`}
                                                    />
                                                    <div className="dateRange-btn-group">
                                                      {values
                                                        .injectionDateRanges
                                                        .length > 1 && (
                                                        <button
                                                          type="button"
                                                          onClick={() =>
                                                            arrayHelpers.remove(
                                                              index
                                                            )
                                                          }
                                                        >
                                                          -
                                                        </button>
                                                      )}
                                                      <button
                                                        type="button"
                                                        onClick={() =>
                                                          arrayHelpers.push({
                                                            dateStartAt: null,
                                                            dateEndAt: null,
                                                            slotStartAt: null,
                                                            slotEndAt: null,
                                                          })
                                                        }
                                                      >
                                                        +
                                                      </button>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div></div>
                                              </div>
                                            </div>
                                          </div>
                                        )
                                      )}
                                    </div>
                                  )}
                                />
                                <hr className="horizontal-line mt-3" />

                                <hr className="horizontal-line mt-3" />
                                <div className="row mt-3">
                                  <div className="col-md-6">
                                    <div>
                                      Expiry Date/Time
                                      <OverlayTrigger
                                        placement="right"
                                        overlay={
                                          <Tooltip>
                                            Expiry date and time must be at
                                            least 2 hours before the start date
                                            and time.
                                          </Tooltip>
                                        }
                                      >
                                        <InfoOutlinedIcon />
                                      </OverlayTrigger>
                                    </div>
                                    <div className="row">
                                      <div className="col-md-6 mb-2 mb-md-0">
                                        <DatePicker
                                          className="custom-input w-100"
                                          name="expiryDate"
                                          selected={values.expiryDate}
                                          onChange={(date) =>
                                            setFieldValue("expiryDate", date)
                                          }
                                          minDate={moment().toDate()}
                                          onBlur={handleBlur("expiryDate")}
                                          dateFormat="dd-MMM-yyyy"
                                          placeholderText="Date*"
                                          autoComplete="off"
                                          showYearDropdown
                                          showMonthDropdown
                                          scrollableMonthYearDropdown
                                          disabled={
                                            duplicate || isDirectConnect
                                              ? false
                                              : isEditCase
                                              ? true
                                              : false
                                          }
                                        />
                                        <ErrorMessage
                                          name="expiryDate"
                                          component="div"
                                          className="text-danger"
                                        />
                                      </div>
                                      <div className="col-md-6 mb-2 mb-md-0">
                                        <CustomTimePicker
                                          minutesStep={15}
                                          updateTimeToParent={(timeText) => {
                                            setFieldValue(
                                              "expiryTime",
                                              timeText
                                            );
                                          }}
                                          time={values.expiryTime}
                                          readOnly={
                                            duplicate || isDirectConnect
                                              ? false
                                              : isEditCase
                                              ? true
                                              : false
                                          }
                                          maxHours={24}
                                          hasInititalValues={isEditCase}
                                        />
                                        <ErrorMessage
                                          name="expiryTime"
                                          component="div"
                                          className="text-danger"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="d-flex gap-2">
                                      <label
                                        className="form-check-label"
                                        htmlFor="TENDER"
                                      >
                                        Upload Terms and Conditions
                                      </label>
                                      {!viewDoc && values?.TENDER && (
                                        <div
                                          className="pointer-event mb-1"
                                          onClick={() =>
                                            handleViewFile(values?.TENDER)
                                          }
                                        >
                                          <OverlayTrigger
                                            placement="right"
                                            overlay={<Tooltip>Preview</Tooltip>}
                                          >
                                            <Preview color="warning" />
                                          </OverlayTrigger>
                                        </div>
                                      )}
                                    </div>
                                    <div className="file-input-wrapper">
                                      <input
                                        type="file"
                                        id="file-input3"
                                        className="file-input"
                                        onChange={(e) =>
                                          handleProofOfPayment(
                                            e,
                                            setFieldValue,
                                            "TENDER",
                                            "TENDER"
                                          )
                                        }
                                        ref={fileInputRef}
                                      />
                                      <span>
                                        {viewDoc ? "" : values.TENDER?.fileName}
                                      </span>
                                      <label
                                        htmlFor="file-input3"
                                        className="file-input-label"
                                      >
                                        Browse
                                      </label>
                                    </div>
                                    <ErrorMessage
                                      name="TENDER"
                                      className="text-danger"
                                      component="div"
                                    />
                                  </div>
                                </div>
                                <small>
                                  *Expiry date/time cannot be edited once the
                                  capacity is created
                                </small>
                                <div className="col-md-12 mb-1 mb-md-0 mt-2 position-relative">
                                  <label htmlFor="comments">Comments</label>
                                  <Field
                                    type="text"
                                    className="custom-input no-spinner"
                                    placeholder=""
                                    name="comments"
                                    value={values.comments}
                                    max="250"
                                  />
                                  <ErrorMessage
                                    name="comments"
                                    className="text-danger"
                                    component="div"
                                  />
                                </div>
                                <hr className="horizontal-line my-4" />
                                <div className="d-flex justify-content-center gap-2">
                                  {duplicate ? (
                                    <button
                                      type="submit"
                                      className="btn btn-signup btn btn-primary"
                                      disabled={isButtonEnabled}
                                    >
                                      Submit
                                    </button>
                                  ) : (
                                    <>
                                      {isDirectConnect ? (
                                        <button
                                          type="submit"
                                          className="btn btn-signup btn btn-primary"
                                        >
                                          Connect
                                        </button>
                                      ) : (
                                        <>
                                          <button
                                            type="submit"
                                            className="btn btn-signup btn btn-primary"
                                            disabled={isButtonEnabled}
                                          >
                                            {isEditCase ? "Update" : "Submit"}
                                          </button>
                                          {isEditCase && (
                                            <div className="d-flex gap-2 ">
                                              <button
                                                className="btn btn-login"
                                                type="button"
                                                onClick={handleHold}
                                              >
                                                {isOpen?.status === "HOLD"
                                                  ? "Release"
                                                  : "Hold"}
                                              </button>
                                              {holdOpen && (
                                                <CustomConfirmBox
                                                  title={
                                                    isOpen?.status === "HOLD"
                                                      ? "Release"
                                                      : "Hold"
                                                  }
                                                  message={`Do you want to ${
                                                    isOpen?.status === "HOLD"
                                                      ? "Release"
                                                      : "Hold"
                                                  } the Capacity?`}
                                                  open={holdOpen}
                                                  handleClose={handleHoldClose}
                                                  handleCloseNo={handleCloseNo}
                                                />
                                              )}
                                              <button
                                                className="btn btn-withdrawal"
                                                type="button"
                                                onClick={handleWithdraw}
                                              >
                                                Withdraw
                                              </button>
                                              {withdrawOpen && (
                                                <CustomConfirmBox
                                                  title="Withdraw"
                                                  message="Do you want to withdraw the Capacity?"
                                                  open={withdrawOpen}
                                                  handleClose={
                                                    handleWithdrawClose
                                                  }
                                                  handleCloseNo={handleWithdraw}
                                                />
                                              )}
                                            </div>
                                          )}
                                        </>
                                      )}
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </Form>
                      );
                    }}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
